import React from 'react';

const QuestionPalette = ({
  questions,
  currentQuestionIndex,
  getQuestionStatus,
  onSelect,
}) => (
  <section className="solution-question-palette">
    <div className="palette-header">
      <div>
        <span>Navigation</span>
        <h2>Questions</h2>
      </div>
      <span className="question-count">
        {Array.isArray(questions) ? questions.length : 0}
      </span>
    </div>

    <div className="solution-palette-grid">
      {Array.isArray(questions) && questions.length ? (
        questions.map((item, index) => {
          const status = getQuestionStatus(item.q_id);
          const active = index === currentQuestionIndex;

          return (
            <button
              type="button"
              key={item.q_id}
              className={`solution-palette-number ${status} ${
                active ? 'active' : ''
              }`}
              onClick={() => onSelect(index)}
              aria-label={`Question ${index + 1}`}
            >
              {index + 1}
            </button>
          );
        })
      ) : (
        <div className="palette-empty">
          Questions will appear here.
        </div>
      )}
    </div>
  </section>
);

export default QuestionPalette;
